var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3482 10.3128C13.7808 11.0627 13.2378 12 12.3737 12H1.12639C0.260683 12 -0.279832 11.0612 0.151933 10.3128L5.77567 0.562149C6.20849 -0.188062 7.29254 -0.186703 7.72459 0.562149L13.3482 10.3128ZM6.75013 8.29688C6.1547 8.29688 5.672 8.77957 5.672 9.375C5.672 9.97043 6.1547 10.4531 6.75013 10.4531C7.34556 10.4531 7.82825 9.97043 7.82825 9.375C7.82825 8.77957 7.34556 8.29688 6.75013 8.29688ZM5.72654 4.42158L5.9004 7.60908C5.90854 7.75823 6.03186 7.875 6.18123 7.875H7.31903C7.46839 7.875 7.59172 7.75823 7.59986 7.60908L7.77371 4.42158C7.7825 4.26047 7.65423 4.125 7.49289 4.125H6.00735C5.846 4.125 5.71775 4.26047 5.72654 4.42158Z",
    fill: "#F51330"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.6d7b462c5dc5f2960e94f43ffdf29ea0.svg";
export { ForwardRef as ReactComponent };